import { getTestId } from '@airtel/air-design-system';
export var defaultProps = Object.assign({
  variation: 'default',
  style: {
    backgroundColor: 'white'
  },
  onButtonPressMetaData: {
    id: '1',
    actions: [{
      payload: {
        duration: 3000,
        toastType: 'error',
        message: 'pressed'
      },
      type: 'showToast'
    }]
  },
  linkListItemProps: {
    heading: 'title text',
    subHeading: 'subtext1 here',
    actionType: 'radio',
    actionTypePosition: 'center',
    avatarIcon: 'TransactionHistoryIcon',
    roundedCorners: true,
    noPadding: false,
    controlState: 'pressed',
    style: {
      backgroundColor: 'white'
    }
  },
  offerStripProps: {
    multiText: [{
      text: '₹30 off ',
      isBold: true,
      type: 'body-single-line-xs'
    }, {
      text: 'on recharge ',
      isBold: false,
      type: 'body-single-line-xs'
    }, {
      text: 'above ₹200',
      isBold: true,
      type: 'body-single-line-xs'
    }],
    actionType: 'button',
    actionTypeProps: {
      iconName: 'RightChevronButtonIcon',
      buttonText: 'Apply'
    }
  },
  calloutProps: [{
    title: '',
    iconName: 'BillIcon',
    state: 'lilac',
    description: 'descriptor1 goes here'
  }, {
    title: '',
    iconName: 'BillIcon',
    state: 'lilac',
    description: 'descriptor1 goes here'
  }],
  buttonProps: {
    buttonType: 'primary',
    iconPosition: 'left',
    iconName: 'AddButtonIcon',
    size: 'md',
    title: 'BUTTON'
  },
  inputProps: {
    placeholder: 'text',
    state: 'none',
    theme: 'light'
  }
}, getTestId('SelectionListWidgetContainer'));